<div class="wrapper">
  <div class="sidebar" data-background-color="brown" data-active-color="danger">
    <div class="logo">
      <a href="https://deanrowallotments.org.uk" class="simple-text logo-mini">
        a
      </a>

      <a routerLink="/" class="simple-text logo-normal">
        DRAT Members
      </a>
    </div>
    <app-left-nav></app-left-nav>    
  </div>
  <router-outlet></router-outlet>
  
</div>